// money-utils.js
'use strict';

const _moneyLog = window.createLogger('MoneyUtils');

function formatMoney(
  amount,
  { currency = 'EUR', locale, isCents = true, minimumFractionDigits = 2, maximumFractionDigits = 2 } = {}
) {
  try {
    // console.log('formatMoney() called with:', { amount, currency, locale, isCents });
    // Ensure numeric input
    let numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (isNaN(numericAmount)) throw new Error('Invalid amount');

    // Convert from cents if needed
    if (isCents) numericAmount = numericAmount / 100;

    // Determine locale (priority: provided → Shopify → localization → fallback)
    let resolvedLocale =
      locale ||
      (typeof window !== 'undefined' && window.Shopify && window.Shopify.locale) ||
      (typeof window !== 'undefined' && window.localization && window.localization.language.iso_code) ||
      'en-GB';
    // EUR → en-IE: guarantees €1,315.00 (Ireland natively uses EUR).
    // USD → en-US: guarantees $362.36 ($ symbol, not US$).
    // All others → en-GB: guarantees English number format (dot decimal, comma
    // thousands) with ISO code prefix. Avoids invalid locales like en-NO that
    // browsers silently downgrade to the native locale.
    const formattingLocale = currency === 'EUR' ? 'en-IE'
                           : currency === 'USD' ? 'en-US'
                           : 'en-GB';
    // console.log('Money formatter locale:', formattingLocale);
    // Format amount
    return new Intl.NumberFormat(formattingLocale, {
      style: 'currency',
      currency,
      minimumFractionDigits,
      maximumFractionDigits
    }).format(numericAmount);
  } catch (err) {
    _moneyLog.warn('formatMoney(): fallback formatting →', err);
    const fallbackAmount = isCents ? amount / 100 : amount;
    return `${currency} ${Number(fallbackAmount).toFixed(2)}`;
  }
}

// ✅ Make globally available for all JS files
window.formatMoney = formatMoney;
